import { getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { store } from '../..';
import { Student } from '@/models/student/student';
import { StudentDraggableExtraArea } from '@/models/student/student-draggable-extra-area';
import { GEnum } from '@/constants/enum.defination';

export interface ISchoolClassChangeModule {
  isDragging: boolean;
  studentShowMode: boolean;
  selectedGrade: number;
  studentDraggableExtraArea: StudentDraggableExtraArea;
}
@Module({ dynamic: true, store, name: 'schoolClassChangeModule', namespaced: true })
class SchoolClassChangeModule extends VuexModule implements ISchoolClassChangeModule {
  isDragging: boolean = false;
  studentShowMode: boolean = true; // true:名前、false:学籍番号
  selectedGrade: number = 0;
  studentDraggableExtraArea: StudentDraggableExtraArea = new StudentDraggableExtraArea();
  bulkMoveModal: boolean = false;
  fromName: string = '';
  fromSchoolClassID: number = 0;
  bulkStudents: Student[] = [];
  clickDragAreaType: GEnum.DragAreaType = GEnum.DragAreaType.TypeSchoolClass;

  @Mutation
  setIsDragging(value: boolean) {
    this.isDragging = value;
  }

  @Mutation
  setStudentShowMode(value: boolean) {
    this.studentShowMode = value;
  }

  @Mutation
  setSelectedGrade(value: number) {
    this.selectedGrade = value;
  }

  @Mutation
  setBulkMoveModal(value: boolean) {
    this.bulkMoveModal = value;
  }

  @Mutation
  setFromName(value: string) {
    this.fromName = value;
  }

  @Mutation
  setFromSchoolClassID(value: number) {
    this.fromSchoolClassID = value;
  }

  @Mutation
  setBulkStudents(value: Student[]) {
    this.bulkStudents = value;
  }

  @Mutation
  setClickDragAreaType(value: GEnum.DragAreaType) {
    this.clickDragAreaType = value;
  }
}

export const schoolClassChangeModule = getModule(SchoolClassChangeModule);
